import AppConstant from '../../config/app.constants';

class CheckInController {
  /*@ngInject*/

  constructor(Auth, $state, User, $translate, BranchService, CustomerService, Modal, RouteService,
    WindowService, TruckService, $q, ScanService, ShipmentService, LocationService, ShiptypeService, SetupService,
    $location, $timeout, $window, Sound, TransactionService, $rootScope, ItemService) {
    this.$translate = $translate
    this.Auth = Auth
    this.$state = $state
    this.User = User
    this.Modal = Modal
    this.ScanService = ScanService
    this.ShipmentService = ShipmentService
    this.LocationService = LocationService
    this.ShiptypeService = ShiptypeService
    this.TransactionService = TransactionService
    this.TruckService = TruckService
    this.SetupService = SetupService
    this.$q = $q
    this.$timeout = $timeout
    this.$location = $location
    this.checkAndCall = false;
    this.Sound = Sound
    this.BranchService = BranchService
    this.CustomerService = CustomerService
    this.RouteService = RouteService
    this.WindowService = WindowService
    this.$rootScope = $rootScope
    this.ItemService = ItemService;
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();
    this.$window = $window
    this.user = null
    this.shpmentsCount = []
    this.branches = []
    this.customers = []
    this.routes = []
    this.windows = []
    this.trucks = []
    this.shiptypes = []
    this.checkinShipmentData = []
    this.branchWiseShipment = []
    this.availableDestinationData = []
    this.getAvailableDestination = [];
    this.routeVerifyData = {};
    this.destinationData = {
      previouslyScannedId: '',
      destinations: {
        self: null,
        deliveryLoc1: null,
        deliveryLoc2: null,
        deliveryLocCod: null,
        deliveryLocCoin: null
      }
    };

    this.scannerBeep = null;
    this.closedRoute = null;
    this.bagIdCopy = null;

    this.bagCheckinError = '';
    this.bagCheckinMessage = '';
    this.shipmentChangeMessage = ''
    this.isShipperChanged = false;
    this.trueOriginalShipperLocationId = null;

    this.wasItemFound = false;
    this.isManuallyAddedShipment = false;
    this.isCheckinSuccessfull = true;
    this.lastScanned = null;
    this.remainingCheckinItemCount = null
    this.resetModel()
    this.resetNewValues()
    this.branchId = this.User.getUser().branchId;
    this.loggedInUser = this.User.getUser().id;
    this.checkInDate = $location.search().routeDate || null;
    this.vaultDate = '';
    this.setupData = '';
    this.shipmentTankerData = [];
    this.disabledBag = false;
    this.isEventFired = false;
    // this.bagScanLimit = AppConstant.scanLimit;
    this.bagScanLimit = "";
    this.checkOnlyOnce = false;
    this.checkLength = 0;
    this.enterSuffix = AppConstant.scan_enter_suffix;
    this.remainingToCheckin = [];
    this.$rootScope.$broadcast('routeChange', '/app/checkin');
    this.shipmentData = {};
    this.locationOnHold = false;

    this.checkInScanTab = {
      shipment: 'shipment',
      items: 'items'
    };

    this.itemStats = {
      cash: 'cash',
      items: 'items'
    }

    this.currentCheckInTab = this.checkInScanTab.shipment;
    this.logisticItemObj = {
      barcode: null,
      itemScanLimitExceed: false,
      allowItemScanOnce: false,
      disableItemScan: false,
      defaultLength: 0,
      lastScannedItem: null,
      lastUpdated: null,
      isError: false,
      itemCheckInError: null,
      itemCheckInMessage: null,
      remainingItemList: [],
      checkedInItemList: [],
      itemDetails: {},
      wasItemFound: false,
      isItemCheckedIn: false,
      remainingItemsCount: 0,
      checkedInItemsCount: 0
    }
    this.manifest = {
      showManifestModal: false,
      totalBagCount: null,
      manifestID: null,
      isSubmitting: false,
      isCompleted: false
    };
  }

  loadWindows() {
    return this.BranchService.get(this.model.branch)
      .then((branch) => {
        this.windows = branch.windows
      })
      .catch((err) => {
        console.log(err)
      })
  }

  loadData() {
    return this.$q.all([
      this.BranchService.all(null, 0, 1000),
      this.RouteService.all(null, 0, 1000),
      this.TruckService.all(null, 0, 1000),
      this.ShiptypeService.all(null, 0, 1000),
      this.ScanService.getShipmentTanker(this.branchId, this.vaultDate)
    ])
      .then((res) => {
        this.branches = res[0].results
        this.routes = res[1].results
        this.trucks = res[2].results
        this.shiptypes = res[3].results
        this.shipmentTankerData = res[4].map((data) => data.tankerId.toUpperCase())
      })
  }

  verifyRoute(routeId, date) {
    return this.ScanService.routeCheckinVerify(this.branchId, routeId, date, this.model.messengerId)
      .then((data) => {
        this.checkInData(routeId);
        this.routeVerifyData = data;

        this.logisticItemObj.remainingItemList = this.routeVerifyData.checkedOutItemList || [];
        this.logisticItemObj.remainingItemsCount = this.logisticItemObj.remainingItemList.length || 0;
        this.logisticItemObj.checkedInItemList = this.routeVerifyData.checkedInItemList || [];
        this.logisticItemObj.checkedInItemsCount = this.logisticItemObj.checkedInItemList.length || 0;
        this.routeVerifyData.errorCount = 0;
        this.remainingCheckinItemCount = 0;
        this.remainingToCheckin = [];

        if (this.routeVerifyData.route) {
          this.routeVerifyData.route.forEach((record) => {

            switch (record.message) {
              case 'E_PICKUP_NOT_CHECKED_IN':
              case 'E_DELIVERY_NOT_DELIVERED':
                if (!(record.isRequiredPickup === 1 && !record.orderNo && record.verified === 0)) {
                  this.remainingCheckinItemCount++
                  this.remainingToCheckin.push(record);
                }
                break;
            }

            if (record.isError || record.message === 'E_LOCATION_NOT_ON_HOLD') {
              this.routeVerifyData.errorCount++
            }
          })
          this.routeVerifyData.errorCount = this.routeVerifyData.errorCount + this.logisticItemObj.remainingItemsCount;
        }
        return data;
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal('error.' + err.data.message);
        }
      })
  }

  focusElementById(id) {
    setTimeout(() => {
      if (!document.getElementById(id)) return;
      document.getElementById(id).focus();
    }, 300)
  }

  loadCheckinDate() {
    this.checkInDate = this.$location.search().routeDate;
    if (!this.checkInDate) {
      const branchId = this.User.getUser().branchId;

      this.SetupService.get(branchId)
        .then((setup) => {
          this.setupData = setup;
          this.checkInDate = moment(setup.currentVaultDate).utc().format('YYYY-MM-DD');
          this.prefixes = setup.prefixes;
          this.vaultDate = moment(setup.currentVaultDate).utc().format('YYYY-MM-DD');
          this.bagScanLimit = setup.packCharLength;
          this.locationOnHold = setup.locationOnHold;
          if (this.setupData.enableAutoSubmit) this.autoSubmitItem = true;
          else this.autoSubmitItem = false;
        })
        .then(() => {
          this.loadData();
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message)
          }
        })
    }
  }

  $onInit() {
    this.model.currentItemStat = this.itemStats.cash;
    this.scannedRouteId = "";
    // focus on the messenger field
    if (!this.hasRoute) {
      this.focusElementById('route-scan-id')
    }
    this.loadCheckinDate();
    this.user = this.User.getUser();
    this.model.branch = this.user.branchId;
  }

  routeScanned() {
    var finalRouteData;
    if (this.scannedRouteId === '' || this.isEventFired) return;

    this.closedRoute = undefined;
    this.lastStatusUpdate = undefined;
    finalRouteData = this.scannedRouteId;
    this.isEventFired = true;

    this.verifyRoute(finalRouteData, this.checkInDate)
      .then((data) => {
        if(!data) return;
        return this.scanRoute(finalRouteData, this.checkInDate);
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.routeError();
          this.Modal.errorModal('error.' + err.data.message)
        }
      })
      .finally(() => {
        this.isEventFired = false;
        this.scannedRouteId = '';
        finalRouteData = '';
      })
  }

  scanRoute(finalRouteData, checkInDate) {
    this.ScanService.scanRoute(this.model.branch, finalRouteData, checkInDate, false, true, true)
      .then((data) => {
        if (data.error) {
          this.isEventFired = false;
          return this.Modal.errorModal(data.error)
        }
        this.model.route = data.route.routeId;
        this.model.routeObj = data.route;
        this.model.loadTruck = true;//!!data.route.loadTruck;
      })
      .then((data) => {
        this.focusElementById('window-scan-id');
        this.Sound.playSuccessBeep("#success_beep");
        this.hasRoute = true;
        this.model.window = "";
      })
      .catch((err) => {
        this.hasRoute = false;
        if (err && err.data && err.data.message) {
          this.routeError();
          this.Modal.errorModal('error.' + err.data.message)
        }
      })
  }

  routeError() {
    this.hasRoute = false;
    this.Sound.PlayErrorBeep("#scanner_beep");
  }

  windowScanned() {
    var finalWindowData;

    // if (this.prefixes && this.prefixes.window) {
    // if (this.model.window.startsWith(this.prefixes.window[0])) {
    // finalWindowData = this.model.window.slice(this.prefixes.window[0].length)
    // } else {
    // finalWindowData = this.model.window;
    // }
    // } else {
    // finalWindowData = this.model.window;
    // }

    finalWindowData = this.model.window;
    this.BranchService.get(this.user.branchId)
      .then((branchObj) => {
        this.hasWindow = branchObj.windows.some((window) => {
          return finalWindowData.toUpperCase() === window.id.toUpperCase();
        })

        if (this.hasWindow) {
          this.model.window = finalWindowData;
          this.focusElementById('messengerId')
          this.Sound.playSuccessBeep("#success_beep");
          this.model.messengerId = "";
        }
        else if (finalWindowData === '') {
          return;
        }
        else {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.model.window = '';
          finalWindowData = '';
          this.Modal.errorModal('error.' + 11000)
        }
      })
  }

  setFocus1(ele) {
    this.focusElementById(this.hasMessenger ? 'bagId' : 'messengerId')
  }

  messengerScanned() {
    var finalMessengerData;
    if (this.model.messengerId === "") {
      return;
    }

    // if (this.prefixes && this.prefixes.messenger) {
    //   if (this.model.messengerId.startsWith(this.prefixes.messenger[0])) {
    //     finalMessengerData = this.model.messengerId.slice(this.prefixes.messenger[0].length)
    //   } else {
    //     finalMessengerData = this.model.messengerId;
    //   }
    // } else {
    //   finalMessengerData = this.model.messengerId;
    // }

    finalMessengerData = this.model.messengerId;
    this.ScanService.scanMessenger(this.model.branch, this.model.route, finalMessengerData, this.checkInDate, true)
      .then((data) => {
        // console.log(data)
        if (data.error) {
          this.model.messengerId = '';
          finalMessengerData = '';
          return this.Modal.errorModal(data.error)
        }
        this.hasMessenger = true
        this.model.messengerId = finalMessengerData;
        if(this.model.routeObj && this.model.routeObj.scanUserItems === 1) {
          this.getCheckinUserAssignedItems()
          }
      })
      .then(() => {
        this.focusElementById('truckId')
        this.Sound.playSuccessBeep("#success_beep");
        if (this.setupData && this.setupData.virtualTankers && this.setupData.defaultFromTankerId && !this.model.fromTanker) {
          this.model.fromTanker = this.setupData.defaultFromTankerId;
        }
        else {
          this.model.fromTanker = "";
        }
      })
      .catch((err) => {
        if (err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.model.messengerId = '';
          finalMessengerData = '';
          return this.Modal.errorModal('error.' + err.data.message)
        }
      })
  }

  resetFromTanker() {
    this.model.fromTanker = "";
    this.Sound.PlayErrorBeep("#scanner_beep");
  }

  getTankerSearchObj(id) {
    return {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          },
          {
            field: 'id',
            condition: '=',
            data: id
          }
        ],
        operator: 'AND'
      }
    };
  }
  fromTankerScanned() {
    var finalFromTankerData;
    if (this.model.fromTanker === "") {
      return;
    }

    if (this.setupData.tankerId.toUpperCase() === this.model.fromTanker) {
      this.resetFromTanker();
      return this.Modal.errorModal('error.' + 90926)
    }
    else if (this.setupData.virtualTankerId.toUpperCase() === this.model.fromTanker) {
      this.resetFromTanker();
      return this.Modal.errorModal('error.' + 90927);
    }
    else if (this.shipmentTankerData.includes(this.model.fromTanker)) {
      this.resetFromTanker();
      return this.Modal.errorModal('error.' + 90928);
    }

    // if (this.prefixes && this.prefixes.tanker) {
    //   if (this.model.fromTanker.startsWith(this.prefixes.tanker[0])) {
    //     finalFromTankerData = this.model.fromTanker.slice(this.prefixes.tanker[0].length)
    //   } else {
    //     finalFromTankerData = this.model.fromTanker;
    //   }
    // } else {
    //   finalFromTankerData = this.model.fromTanker;
    // }

    finalFromTankerData = this.model.fromTanker;
    let searchObj = this.getTankerSearchObj(finalFromTankerData)
    this.LocationService.all(searchObj, 0, 1000)
      .then((res) => {
        let tanker = res.results[0]
        if (tanker.locationType !== 'TANKER') {
          this.model.toTanker = "";
          return this.Modal.errorModal('error.' + 90914)
        }

        this.hasFromTanker = !!finalFromTankerData;
        this.model.fromTanker = finalFromTankerData;

        // Always ask for ToTanker, irrespective of loadTruck value
        if (this.model.loadTruck) {
          this.focusElementById('toTanker');
          this.Sound.playSuccessBeep("#success_beep");
          if (this.setupData && this.setupData.virtualTankers && this.setupData.defaultToTankerId && !this.model.toTanker) {
            this.model.toTanker = this.setupData.defaultToTankerId;
          }
          else {
            this.model.toTanker = "";
          }
        }
        else {
          this.showCheckin = true;
        }
      })
      .catch((err) => {
        this.Sound.PlayErrorBeep("#scanner_beep");
        this.model.fromTanker = "";
        finalFromTankerData = "";
        return this.Modal.errorModal('error.' + 90914)
      });
  }

  toTankerScanned() {
    let finalToTankerData,
      holdTanker = this.setupData.tankerId,
      virtualTanker = this.setupData.virtualTankerId;

    if (this.model.toTanker === "") {
      return;
    }

    if (holdTanker.toUpperCase() === this.model.toTanker) {
      this.resetToTanker();
      return this.Modal.errorModal('error.' + 90926)
    }
    else if (virtualTanker.toUpperCase() === this.model.toTanker) {
      this.resetToTanker();
      return this.Modal.errorModal('error.' + 90927);
    }
    else if (this.model.toTanker === this.model.fromTanker) {
      this.resetToTanker();
      return this.Modal.errorModal('error.' + 90929);
    }

    finalToTankerData = this.model.toTanker;
    let searchObj = this.getTankerSearchObj(finalToTankerData)
    this.LocationService.all(searchObj, 0, 1000)
      .then((res) => {
        let tanker = res.results[0];
        if (tanker.locationType !== 'TANKER') {
          this.resetToTanker();
          return this.Modal.errorModal('error.' + 90911)
        }
        this.focusElementById('barcode');
        this.hasToTanker = this.showCheckin = !!this.model.toTanker;
      })
      .catch((err) => {
        this.resetToTanker();
        return this.Modal.errorModal('error.' + 90911)
      });
  }

  resetToTanker() {
    this.model.toTanker = "";
    this.Sound.PlayErrorBeep("#scanner_beep");
    // return this.Modal.errorModal('error.' + 90911)
  }

  setDestination(destination) {
    this.isDestinationChanged = this.model.destination.id !== destination.id;
    this.newValues.destination = destination;
  }

  stopPropagation(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  // get checkedIn shipment based on branchId and routeId
  checkInData(routeId) {
    this.ScanService.shipmentCheckInCheckOutData(this.model.branch, routeId, this.vaultDate)
      .then((data) => {
        this.checkedInItem = data.checkInCheckOutCount.totalCheckedInItemCount;
      })
      .catch((err) => {
        console.log(err);
      })
  }

  checkinBag() {
    const fromLocationId = (this.model.shipper && this.model.shipper.Value !== this.trueOriginalShipperLocationId) ? this.model.shipper.Value : undefined;
    const isManuallyAddedShipment = this.isManuallyAddedShipment;
    this.isManuallyAddedShipment = false;
    return this.ShipmentService.checkinShipment(this.model.branch, this.model.bagId, this.model.route, this.checkInDate, this.model.window, this.model.fromTanker, this.model.toTanker, fromLocationId, isManuallyAddedShipment)
      .then((response) => {

        if (response.error) {
          this.isError = true;
          return this.Modal.errorModal(response.error)
        }
        // if (this.remainingCheckinItemCount >= 0) {
        //   this.remainingCheckinItemCount--
        // }
        this.clearScan()
        this.Sound.playSuccessBeep("#success_beep");
      })
      .finally(() => {
        this.verifyRoute(this.model.route, this.checkInDate)
        this.lastStatusUpdate = new Date();
      })
  }

  // autoSubmit() {
  //   // this.isProvisionalCredit = false;
  //   const bagScannedPromise = this.bagScanned();
  //   //in case of error bagScanned returns non promise values are returned ther's a check for .then function
  //   if (bagScannedPromise && typeof bagScannedPromise.then === "function") {
  //     bagScannedPromise.then(() => {
  //       return this.bagSubmitted();
  //     })
  //   }

  //   return bagScannedPromise;
  // }

  callCheckinBag() {
    if (!this.model.bagId || this.isError) {
      this.isEventFired = false;
      return Promise.resolve();
    }
    const successMessage = this.model.bagId + " " + this.$translate.instant('checkin.checkedin');

    this.isError = false;
    this.bagCheckinMessage = '';
    return this.checkinBag()
      .then(() => {
        this.bagCheckinMessage = successMessage;
        this.isEventFired = false;
      })
      .catch((err) => {
        this.isEventFired = false;
        this.isError = true;
        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.bagCheckinError = this.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        }
        else {
          this.bagCheckinError = err.toString()
        }
      })
  }

  bagSubmitted() {
    return new Promise((resolve, reject) => {
      // if (this.newValues.amount <= 0) {
      //   this.Modal.errorModal("Cannot allow shipment check-in with a $0 amount.");
      //   return reject();
      // }
      const shipment = this.Shipmentresponse || (this.shipmentData && this.shipmentData.shipment);

      this.proceedWithCheckIn(shipment, resolve, reject);
    });
  }

  proceedWithCheckIn(shipment, resolve, reject) {
    if (shipment && (shipment.orderNo === null || shipment.orderNo === "") && (!shipment.verified || shipment.verified === 0) && (shipment.isRequiredPickup || shipment.isRequiredPickup === 1)) {
      this.Modal.confirmSupervisor('checkin-not-picked-up', {}, ({ modal, supId }) => {
        this.callCheckinBag()
          .then(() => {
            modal.close();
            resolve();
          })
          .catch((err) => {
            modal.close();
            reject(err);
          });
      }, ({ modal }) => {
        modal.close();
        this.isEventFired = false;
        this.disabledBag = false;
        this.focusElementById('bagId');
        reject('Supervisor challenge cancelled');
      });
      return;
    }

    if (this.shipmentData && this.shipmentData.shipment && this.shipmentData.shipment.shiptypeId === 'BULKCASH' && this.locationData && this.locationData.locationType === 'BANK' && this.locationData.centralBank === true) {
      this.manifest.showManifestModal = true;
      resolve();
    } else {
      this.callCheckinBag()
        .then(resolve)
        .catch(reject);
    }
  }

  editShipper(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!this.model.bagId) return;

    this.isEditingShipper = true;
    this.loadShipperLocations('', 0);
    this.focusElementById('shipperSelection');
  }

  onShipperSelected() {
    this.$timeout(() => {
      if (!this.selectedShipperLocation) {
        this.selectedShipperLocation = this.originalShipperLocationObj;
      }

      this.model.shipper = {
        name: this.selectedShipperLocation.dataObj ? this.selectedShipperLocation.dataObj.name : this.selectedShipperLocation.name,
        address: this.selectedShipperLocation.dataObj ? this.selectedShipperLocation.dataObj.address : this.selectedShipperLocation.address,
        Value: this.selectedShipperLocation.Value,
        Key: this.selectedShipperLocation.Key
      };

      this.isShipperChanged = (this.model.shipper.Value || null) !== (this.originalShipperLocationId || null);

      this.isEditingShipper = false;
    });
  }

  mappingData(arr, label, value) {
    return arr.map((item) => {
      const arrayObject = {
        Key: item[value] + ' | ' + item[label],
        Value: item[value],
        value: item[value],
        label: item[label],
        dataObj: item
      };
      return arrayObject;
    });
  }

  loadShipperLocations(searchKey, offset) {

    searchKey = searchKey || '';
    
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.branchId
          },
          {
            field: 'active',
            condition: '=',
            data: true
          },
          {
            group: {
              rules: [
                {
                  field: 'id',
                  condition: 'like',
                  data: '%' + searchKey + '%'
                },
                {
                  field: 'name',
                  condition: 'like',
                  data: '%' + searchKey + '%'
                }
              ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      }
    };

    this.shipperLocationsLoading = true;
    return this.LocationService.all(searchObj, offset, AppConstant.defaultPageLimit || 10)
      .then((res) => {
        const locations = this.mappingData(res.results, 'name', 'id');
        if (offset === 0 || offset === undefined) {
          this.shipperLocationObj = {
            total: res.total,
            results: locations
          };
        } else {
          this.shipperLocationObj.results = this.shipperLocationObj.results.concat(locations);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.shipperLocationsLoading = false;
      });
  }
  
  setAvailableDestinations(fromLocationId, toLocationData, shiptypeId) {
    const destinationsLoadedDefer = this.$q.defer();
    const addAvailableDestinations = (locationFields) => {
      const addedDesintationIds = [];

      locationFields.forEach((field) => {
        const destinationObj = this.destinationData.destinations[field];

        if (destinationObj && addedDesintationIds.indexOf(destinationObj.value) === -1) {
          this.availableDestinations.push(destinationObj);
          addedDesintationIds.push(destinationObj.value);
        }
      });
    }

    this.destinationData.destinations.self = {
      name: toLocationData.name,
      address: toLocationData.address,
      value: toLocationData.id
    }

    if (this.destinationData.previouslyScannedId === fromLocationId) {
      destinationsLoadedDefer.resolve();
    }
    else {
      this.LocationService.get(fromLocationId)
        .then((locationData) => {
          const destinations = this.destinationData.destinations;
          const locationFields = ['deliveryLoc1', 'deliveryLoc2', 'deliveryLocCod', 'deliveryLocCoin'];

          this.locationData = locationData;

          locationFields.forEach((field) => {
            const locationObj = locationData[field]

            if (locationObj && locationObj.id) {
              destinations[field] = {
                name: locationObj.name,
                address: locationObj.address,
                value: locationObj.id,
                city: locationObj.city,
                zip: locationObj.zip,
                state: locationObj.state,
                country: locationObj.country
              }
            }
          });

          destinationsLoadedDefer.resolve();
        })
    }

    return destinationsLoadedDefer.promise
      .then(() => {
        const coinLocations = ['self', 'deliveryLocCoin'];
        const cashLocations = ['self', 'deliveryLoc1', 'deliveryLoc2', 'deliveryLocCod'];
        let locationFields = [];
        // this.getAvailableDestination = [];
        this.availableDestinations = [];

        this.selectedShiptype = this.shiptypes.find((shiptype) => {
          return shiptype.id === shiptypeId;
        });

        locationFields = this.selectedShiptype.coinFlag ? coinLocations : cashLocations;

        let areAllDestinationsNull = locationFields
          .slice(1) // remove 'self'
          .every((deliverToField) => { //checks whether for a given location field the value is falsy
            return !this.destinationData.destinations[deliverToField];
          });

        if (areAllDestinationsNull) { // if destinations other than self are null then select locationFields of other group
          locationFields = this.selectedShiptype.coinFlag ? cashLocations : coinLocations;
        }

        return addAvailableDestinations(locationFields);
      });
  }

  keyPressed(controlId, $event) {
    const ESC_KEY_CODE = 27;
    const BACKSPACE_KEY_CODE = 8;
    if (controlId === 'bagId') {
      if ($event.keyCode === ESC_KEY_CODE) {
        this.clearScan(true)
      }
      if ($event.keyCode === BACKSPACE_KEY_CODE && this.model.bagId && this.model.bagId.length <= 1) {
        this.clearScan(true)
      }
    }
  }

  scanSuffix(value) {
    if (this.enterSuffix.length > 0 && value && value.toUpperCase().endsWith(this.enterSuffix)) {
      const bagIdLength = value.length;
      return value.slice(0, bagIdLength - this.enterSuffix.length)
    }
    else return value;
  }

  autoSubmit() {
    this.verifyProvisionalCashShipment();
    const bagScannedPromise = this.bagScanned();

    setTimeout(() => {
      if (bagScannedPromise && typeof bagScannedPromise.then === "function") {
        bagScannedPromise.then(() => {
          setTimeout(() => {
            return this.bagSubmitted();
          }, 700)
        })
      }
    }, this.interval)

    return bagScannedPromise;
  }

  verifyProvisionalCashShipment() {
    const provisionalCredit = _.find(this.routeVerifyData.route, { 'trackingId': this.model.bagId });
    this.isProvisionalCredit = provisionalCredit && provisionalCredit.shiptypeId === 'PC' ? true : false;
    this.interval = this.isProvisionalCredit ? 1500 : 0;
  
    if (this.isProvisionalCredit) {
      document.getElementById('bagId').blur();
      const element = document.getElementById("provisional-credit");
      if (!element) return;
      element.style.display = 'flex';
    }
  }

  removeOverlayToast() {
    setTimeout(() => {
      const element = document.getElementById("provisional-credit");
      if (!element) return;
      this.focusElementById('bagId');
      element.style.display = 'none';
    }, this.interval)
  }

  bagScanned() {
    this.checkAndCall = false;
    this.model.bagId = this.scanSuffix(this.model.bagId);

    if (!this.model.bagId || this.isEventFired) {
      return;
    }

    this.bagScanLimitExceed = false;

    if (this.bagScanLimit && this.bagScanLimit > 0) {
      if (this.model.bagId.length > this.bagScanLimit && (!this.checkOnlyOnce || this.model.bagId.length !== this.checkLength)) {
        delete this.bagCheckinError;
        delete this.bagCheckinMessage;
        delete this.shipmentChangeMessage;
        this.bagScanLimitExceed = true;
        this.checkOnlyOnce = true;
        this.lastScanned = this.model.bagId;
        this.checkLength = this.model.bagId.length;
        this.model.bagId = "";
        this.lastStatusUpdate = new Date();
        return this.bagScanError = this.$translate.instant('common.bagScanError')
      }
      else {
        this.checkLength = this.model.bagId.length > this.bagScanLimit ? this.model.bagId.length : this.bagScanLimit;
      }
    }

    if (this.isDestinationChanged || this.isAmountChanged) {
      this.checkAndCall = true;
      return this.saveChanges()
    }

    if (!this.model.window) {
      return this.Modal.errorModal('11000')
    }

    delete this.lastStatusUpdate

    if (this.bagIdCopy === this.model.bagId && this.isCheckinSuccessfull) {
      this.isEventFired = true;
      this.isCheckinSuccessfull = false;
      return this.bagSubmitted()
    }
    else {
      this.bagIdCopy = this.model.bagId;
      this.lastScanned = this.model.bagId;
    }

    this.isError = false;
    this.wasItemFound = true;
    this.bagCheckinError = '';

    this.resetNewValues()
    this.getAvailableDestination = [];
    this.Shipmentresponse = [];
    this.fuzzyMatch = false;
    this.disabledBag = true;
    
    return this.ShipmentService.verifyShipment(this.model.branch, this.model.bagId, this.model.route, this.checkInDate, this.model.window, this.model.fromTanker, this.model.toTanker)
      .then((response) => {
        this.verifyProvisionalCashShipment();
        this.removeOverlayToast();
        this.shipmentData = response;
        this.Shipmentresponse = response.shipment;
        if (response.window.fuzzyMatching) {
          this.fuzzyMatch = true;
          this.isEventFired = true;
          return this.Modal.checkedInShipmentSelectionModal({
            bagId: this.model.bagId,
            branchId: this.model.branch,
            windowId: this.model.window,
            routeId: this.model.route,
            date: this.checkInDate
          }, response.shipments, ({ modal, isCreated, selected, supervisorId }) => {

            const bagDefer = this.$q.defer();

            if (isCreated) {
              this.ShipmentService.create(selected)
                .then(() => {
                  bagDefer.resolve();
                })
                .catch((err) => {
                  bagDefer.reject(err);
                })
            }
            else {
              bagDefer.resolve();
            }

            bagDefer.promise
              .then(() => {
                this.model.bagId = selected.trackingId;
                this.isEventFired = false;
                this.autoSubmit();
                this.verifyRoute(this.model.route, this.checkInDate)
                this.disabledBag = false;
                if (modal) modal.close();
              })
              .catch((err) => {
                this.disabledBag = false;
                this.isEventFired = false;
                if (err && err.data && err.data.message) {
                  // this.model.bagId = '';
                  this.Sound.PlayErrorBeep("#scanner_beep");
                  return this.Modal.errorModal("error." + err.data.message);
                }
                else {
                  console.log(err);
                }
              })
          }, ({ modal }) => {
            if (modal) modal.close();
            this.isEventFired = false;
            this.disabledBag = false;
            this.focusElementById('bagId');
          })
        }
        return response;
      })
      .then((response) => {
        return this.getDestinationList();
      })
      .then((response) => {

        if (response.error) {

          this.lastStatusUpdate = new Date();
          this.isError = true;
          // this.model.bagId = '';
          return this.Modal.errorModal(response.error.message)
        }

        this.disabledBag = false;
        this.isCheckinSuccessfull = true;
        this.model.coinFlag = response.shipment.coinFlag

        this.model.shipper = {
          name: response.shipment.fromLocationName,
          address: response.shipment.fromAddress,
          Value: response.shipment.fromLocationId,
          Key: response.shipment.fromLocationId + ' | ' + response.shipment.fromLocationName
        };

        this.trueOriginalShipperLocationId = response.shipment.fromLocationId;
        this.originalShipperLocationId = response.shipment.fromLocationId;
        this.originalShipperLocationObj = {
          name: response.shipment.fromLocationName,
          address: response.shipment.fromAddress,
          Value: response.shipment.fromLocationId,
          Key: response.shipment.fromLocationId + ' | ' + response.shipment.fromLocationName
        };
        this.selectedShipperLocation = {
          name: response.shipment.fromLocationName,
          address: response.shipment.fromAddress,
          Value: response.shipment.fromLocationId,
          Key: response.shipment.fromLocationId + ' | ' + response.shipment.fromLocationName
        };

        this.model.id = response.shipment.shipmentId;
        const dest = this.getAvailableDestination.length ? this.getSelectedDestination(this.getAvailableDestination) : this.Shipmentresponse;
        this.model.destination = this.newValues.destination = Array.isArray(dest) ? (dest.length ? dest[0] : null) : dest;
        this.model.shiptype = this.newValues.shiptype = response.shipment.shiptypeId;
        this.model.amount = this.newValues.amount = response.shipment.amount;
        
        setTimeout(()=>{
        if(this.model.amount !== null && this.model.amount <= 1 && this.model.amount !== ''){
          this.Sound.PlayErrorBeep("#scanner_beep");
        }
      },500)

        this.model.quantity = this.newValues.quantity = response.shipment.qty || 1;
        this.newValues.shiptypeUnitAmount = response.shipment.shiptypeAmount;
        this.focusElementById('bagId');
      })
      .catch((err) => {
        this.focusElementById('bagId');
        this.disabledBag = false;
        if (!this.fuzzyMatch && this.isEventFired) {
          this.isEventFired = false;
        }
        this.isCheckinSuccessfull = false;

        this.isError = true;

        if (this.fuzzyMatch == false) {
          this.lastStatusUpdate = new Date();
        }

        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.bagCheckinError = this.$translate.instant('error.' + err.data.message) || null;
          this.lastScanned = this.model.bagId;
          this.model.bagId = "";
        }

        if (err && err.data && err.data.message === '90908') {

          // load shipment details for displaying purpose
          this.ShipmentService.get(this.lastScanned)
            .then((shipmentData) => {
              this.shipmentDetails = shipmentData;
              this.setAvailableDestinations(shipmentData.fromLocationId, shipmentData.toLocation, shipmentData.shiptypeId)
                .then(() => {
                  this.Sound.PlayErrorBeep("#scanner_beep");
                  this.isCheckinSuccessfull = false;
                  this.model.coinFlag = shipmentData.coinFlag

                  this.model.shipper = {
                    name: shipmentData.fromLocation.name,
                    address: shipmentData.fromLocation.address,
                    Value: shipmentData.fromLocationId,
                    Key: shipmentData.fromLocationId + ' | ' + shipmentData.fromLocation.name
                  };

                  this.trueOriginalShipperLocationId = shipmentData.fromLocationId;
                  this.originalShipperLocationId = shipmentData.fromLocationId;
                  this.originalShipperLocationObj = {
                    name: shipmentData.fromLocation.name,
                    address: shipmentData.fromLocation.address,
                    Value: shipmentData.fromLocationId,
                    Key: shipmentData.fromLocationId + ' | ' + shipmentData.fromLocation.name
                  };
                  this.selectedShipperLocation = {
                    name: shipmentData.fromLocation.name,
                    address: shipmentData.fromLocation.address,
                    Value: shipmentData.fromLocationId,
                    Key: shipmentData.fromLocationId + ' | ' + shipmentData.fromLocation.name
                  };

                  this.model.id = shipmentData.id
                  this.model.destination = this.newValues.destination = this.availableDestinations[0]
                  this.model.shiptype = this.newValues.shiptype = shipmentData.shiptypeId
                  this.model.amount = this.newValues.amount = shipmentData.amount
                  this.model.quantity = this.newValues.quantity = shipmentData.qty || 1
                  this.newValues.shiptypeUnitAmount = shipmentData.shiptypeAmount;
                })
                .then(() => {
                  this.Modal.itemNotDelivered(this.lastScanned, this.shipmentDetails, this.setupData.notDeliveredResolution, ({ $scope, modal }) => {
                    $scope.model.loading = true;
                    let promise = Promise.resolve();
                    promise = promise.then(() => {
                      // !this.shipmentDetails.shiptype.coinFlag || !this.shipmentDetails.orderNo
                      if (this.setupData.notDeliveredResolution) {
                        if ($scope.model.isReRoute) {
                          // re route shipment
                          return this.ShipmentService.shipmentReRoute(
                            this.model.branch,
                            this.lastScanned,
                            this.model.route,
                            $scope.model.routeId, //destRouteId, 
                            $scope.model.date ? moment($scope.model.date).utc(true).format('YYYY-MM-DD') : '',
                            $scope.model.supervisorId,
                            $scope.model.selectedReason,
                            $scope.model.deliveryResolution,
                            $scope.model.note,
                            $scope.model.updatedTrackingId,
                            $scope.model.originalTrackingId,
                            $scope.model.amount, 
                            $scope.model.qty,
                            $scope.model.toLocationListObj.destinationId.Value,
                            $scope.model.fromLocationListObj.fromLocationId.Value, 
                            $scope.model.shipTypeObj.shiptypeId.Value
                          )
                        } else {
                          // hold Shipment Not Delivered
                          return this.ShipmentService.holdShipmentNotDelivered(
                            this.model.branch,
                            this.lastScanned,
                            this.model.route,
                            this.checkInDate,
                            $scope.model.supervisorId,
                            $scope.model.selectedReason,
                            $scope.model.deliveryResolution,
                            $scope.model.note,
                            this.setupData.notDeliveredResolution,
                            'Hold',
                            $scope.model.updatedTrackingId,
                            $scope.model.originalTrackingId,
                            $scope.model.amount, 
                            $scope.model.qty,
                            $scope.model.toLocationListObj.destinationId.Value,
                            $scope.model.fromLocationListObj.fromLocationId.Value, 
                            $scope.model.shipTypeObj.shiptypeId.Value
                          )
                        }
                      } else {
                        // only hold
                        return this.ShipmentService.putShipmentOnHold(
                          this.model.branch,
                          this.lastScanned,
                          this.model.route,
                          this.checkInDate,
                          $scope.model.supervisorId,
                          $scope.model.selectedReason,
                          'Hold',
                          $scope.model.updatedTrackingId,
                          $scope.model.originalTrackingId,
                          $scope.model.amount, 
                          $scope.model.qty,
                          $scope.model.toLocationListObj.destinationId.Value,
                          $scope.model.fromLocationListObj.fromLocationId.Value, 
                          $scope.model.shipTypeObj.shiptypeId.Value
                        );
                      }
                    })
                      .then(() => {
                        this.isError = false
                        modal.close();
                        this.Sound.playSuccessBeep("#success_beep");
                        this.bagCheckinMessage = (this.setupData.notDeliveredResolution && $scope.model.isReRoute)  ? this.$translate.instant('checkin.reRoute') : this.$translate.instant('checkin.putOnHold');
                        return this.verifyRoute(this.model.route, this.checkInDate)
                      })
                      .catch((err) => {
                        this.lastStatusUpdate = new Date();
                        this.isError = true;
                        if (modal) modal.close();
                        // this.model.bagId = '';
                        this.Sound.PlayErrorBeep("#scanner_beep");
                        if (err && err.data && err.data.message) {
                          // this.bagCheckinError = this.$translate.instant('error.' + err.data.message) || null;
                          return this.Modal.errorModal('error.' + err.data.message)
                        }
                      })
                      .finally(() => {
                        this.clearScan()
                        $scope.model.loading = false;
                        if (modal) modal.close();
                      });

                  }, ({ modal }) => {
                    if (modal) modal.close();
                  });
                })
                .catch((err) => {
                  this.Sound.PlayErrorBeep("#scanner_beep");
                  // this.model.bagId = '';
                  console.log(err);
                });
            }).catch((err) => {
              // this.model.bagId = '';
              this.Sound.PlayErrorBeep("#scanner_beep");
              console.log(err);
            });
        }
        if (err && err.data && err.data.message === '90905') { //item not found
          this.wasItemFound = false;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.isEventFired = true;
          // this.isError = false;
          this.forceAddBag();
        }
        if (err && err.data && err.data.message === '90922') {
          setTimeout(() => {
            this.isDisableRefreshButton = true;
            this.Modal.bagRemoveConfirmation({ bagId: this.lastScanned, cancelSupervisorChallenge: this.setupData.cancelSupervisorChallenge }, ({ modal, $scope }) => {
              if ($scope.isSupervisorConfirmed) {
                this.clearScan(true);
                this.clearItemScan();
                this.isDisableRefreshButton = false;
                this.routeVerifyData.route = this.routeVerifyData.route.filter(t => t.trackingId !== this.lastScanned);
                this.routeVerifyData.errorCount = 0;
                this.remainingCheckinItemCount = 0;
                this.remainingToCheckin = [];

                if (this.routeVerifyData.route) {
                  this.routeVerifyData.route.forEach((record) => {

                    switch (record.message) {
                      case 'E_PICKUP_NOT_CHECKED_IN':
                      case 'E_DELIVERY_NOT_DELIVERED':
                        if (!(record.isRequiredPickup === 1 && !record.orderNo && record.verified === 0)) {
                          this.remainingCheckinItemCount++
                          this.remainingToCheckin.push(record);
                        }
                        break;
                    }

                    if (record.isError || record.message === 'E_LOCATION_NOT_ON_HOLD') {
                      this.routeVerifyData.errorCount++
                    }
                  })
                  this.routeVerifyData.errorCount = this.routeVerifyData.errorCount + this.logisticItemObj.remainingItemsCount;
                }

                modal.close();
              }
            }, ({ modal }) => {
              if (modal) modal.close();
            });
          }, 500);
        }
      })
  }

  getDestinationList(shiptype, field) {
    const defer = this.$q.defer();
    this.gettingDestination = true;
    const shiptypeId = shiptype ? shiptype : this.shipmentData.shipment.shiptypeId;
    this.ShipmentService.getDestinationLocations(this.shipmentData.shipment.fromLocationId, shiptypeId, false)
      .then((responses) => {
        this.getAvailableDestination = responses;

        if (this.shipmentData.shipment && this.shipmentData.shipment.toLocationId) {
          this.focusElementById('destinationSelection')
          const rawSelectedDest = this.getAvailableDestination.length ? this.getSelectedDestination(this.getAvailableDestination) : null;
          const selectedDest = Array.isArray(rawSelectedDest) ? (rawSelectedDest.length ? rawSelectedDest[0] : null) : rawSelectedDest;
          return this.setAvailableDestinations(this.getAvailableDestination.length ? this.shipmentData.shipment.fromLocationId : this.shipmentData.shipment.toLocationId, {
            id: selectedDest ? selectedDest.id : this.Shipmentresponse.toLocationId,
            name: selectedDest ? selectedDest.name : this.Shipmentresponse.toLocationName,
            address: selectedDest ? selectedDest.address : this.Shipmentresponse.toAddress
          }, shiptypeId)
            .then(() => {
              this.gettingDestination = false;
              defer.resolve(this.shipmentData);
            })
            .catch((err) => {
              console.error(err);
            })
        }
        else {
          defer.resolve(this.shipmentData);
        }
      })
    return defer.promise;
  }

  changeShipType(shiptype, field) {
    this.getDestinationList(shiptype, field)
      .then((response) => {
        this.setDestinations(response)
      })
      .then(() => {
        return this.shipmentAmountChanged(field);
      })
  }

  resetShipType() {
    this.getDestinationList()
      .then((response) => {
        this.setDestinations(response)
      })
      .then(() => {
        this.resetChanges();
      })
      .then(() => {
        const selectedShiptype = this.shiptypes.find((shiptype) => {
          return shiptype.id === this.newValues.shiptype;
        });
        this.newValues.shiptypeUnitAmount = selectedShiptype.amount
        this.model.coinFlag = selectedShiptype.coinFlag
      })
  }

  setDestinations(response) {
    if (response.error) {

      this.lastStatusUpdate = new Date();
      this.isError = true;
      return this.Modal.errorModal(response.error.message)
    }
    this.disabledBag = false;
    this.isCheckinSuccessfull = true;

    this.model.shipper = {
      name: response.shipment.fromLocationName,
      address: response.shipment.fromAddress
    };

    this.model.id = response.shipment.shipmentId
    const dest = this.getAvailableDestination.length ? this.getSelectedDestination(this.getAvailableDestination) : this.Shipmentresponse;
    this.model.destination = this.newValues.destination = Array.isArray(dest) ? (dest.length ? dest[0] : null) : dest;
  }

  override() {
    this.Modal.confirmSupervisor('checkin-override', null, ({ modal, supId }) => {
      if (supId) {
        return this.loadWindows()
          .then(() => {
            this.overridenBySupervisor = true
          })
          .catch((err) => {
            console.log(err)
          })
      }
      modal.close()
    }, ({ modal }) => {
      modal.close()
    })
  }

  saveOverride() {
    this.overridenBySupervisor = false
  }

  closeRoute() {
    if (this.isEventFired) return;
    this.isEventFired = true;
    this.RouteService.closeRoute(this.model.branch, this.model.route, this.checkInDate, this.model.window)
      .then((data) => {
        // console.log(data);
        this.isEventFired = false;
        if (!data.isError) {
          this.Sound.playSuccessBeep("#success_beep");
          this.closedRoute = this.model.route;
          this.lastStatusUpdate = new Date();
          this.resetModel()
          this.resetChanges()
          this.focusElementById('route-scan-id')
        }
        else {
          this.Modal.errorModal(data.messageCode);
        }

        return;
      })
      .catch((err) => {
        this.isEventFired = false;
        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.Modal.errorModal(err.data.message)
        }
        else {
          console.error(err)
        }
      })
  }

  forceClose() {
    if (this.isEventFired) return;
    this.isEventFired = true;

    let holdShipments = [], deliveredShipments = [], holdLocations = [], missingPickups = [];

    this.Modal.checkinForceCloseRoute(this.model.route, this.routeVerifyData, this.logisticItemObj.remainingItemList, ({ $scope, action, modal, scanValue }) => {
      if (action === 'scan') {
        this.isEventFired = false;
        this.model.bagId = "";
        modal.close()
        this.focusElementById('bagId')
        return
      }

      $scope.model.routeVerifyResults
        .filter((record) => {
          return record.isOverridable
            && record.selectedReason
            && (record.isError || ['E_LOCATION_NOT_ON_HOLD', 'MISSING_PICKUP'].includes(record.message));
        })
        .map((record) => {
          switch (record.message) {
            case 'E_PICKUP_NOT_CHECKED_IN':
            case 'E_DELIVERY_NOT_DELIVERED': {
              if (record.selectedReason === 'Delivered') {
                deliveredShipments.push({
                  trackingId: record.trackingId,
                  fromLocationId: record.fromLocationId,
                  toLocationId: record.toLocationId,
                  pickupDate: record.pickupDate,
                  branchId: this.model.branch,
                  routeId: this.model.route,
                  vaultDate: this.checkInDate,
                });
              } else if (record.selectedReason !== 'Delivered') {
                holdShipments.push({
                  branch: this.model.branch,
                  route: this.model.route,
                  checkInDate: this.checkInDate,
                  supervisorId: $scope.model.supervisorId,
                  comment: ' ',
                  routeVerifyResults: [{
                    isError: record.isError,
                    isOverridable: record.isOverridable,
                    selectedReason: record.selectedReason,
                    trackingId: record.trackingId,
                  }]
                });
              }
              break;
            }

            case 'E_LOCATION_NOT_ON_HOLD': {
              if (this.locationOnHold) {
                holdLocations.push({
                  locationId: record.locationId,
                  route: this.model.route,
                  checkInDate: this.checkInDate,
                  selectedReason: record.selectedReason,
                  comment: ' ',
                  supervisorId: $scope.model.supervisorId,
                });
              }
              break;
            }

            case 'MISSING_PICKUP': {
              missingPickups.push({
                locationId: record.locationId,
                routeId: this.model.route,
                vaultDate: this.checkInDate,
                selectedReason: record.selectedReason,
                comments: record.noPickupComment,
                supervisorId: $scope.model.supervisorId,
                messengerId: this.model.messengerId,
                shiptypeId: record.shiptypeId
              });
              break;
            }
          }
        })

      this.$q.all([
        this.ShipmentService.bulkHoldShipment(holdShipments),
        this.ShipmentService.bulkUpdateDeliveredShipment(deliveredShipments, this.model.branch),
        this.LocationService.bulkHoldLocations(holdLocations, this.model.branch),
        this.logisticItemBulkHold(),
        this.ShipmentService.bulkUpdateNoPickupStop(missingPickups, this.model.branch)
      ])
        .then(() => this.verifyRoute(this.model.route, this.checkInDate))
        .then(() => {
          const hasBlockingRouteIssues = (this.routeVerifyData.route || []).some((record) => {
            if (record.message === 'E_LOCATION_NOT_ON_HOLD' && this.locationOnHold === false) {
              return false;
            }

            return record.isError || record.message === 'MISSING_PICKUP';
          });

          const hasBlockingIssues = hasBlockingRouteIssues || this.logisticItemObj.remainingItemsCount > 0;

          if (!hasBlockingIssues) {
            return this.RouteService.closeRoute(this.model.branch, this.model.route, this.checkInDate, this.model.window);
          }
          else {
            return null;
          }
        })
        .then((data) => {
          if (data && !data.isError) {
            this.closedRoute = this.model.route
            this.lastStatusUpdate = new Date();
            this.resetModel()
            this.focusElementById('route-scan-id')
            this.Sound.playSuccessBeep("#success_beep");
          }
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Sound.PlayErrorBeep("#scanner_beep");
            this.Modal.errorModal('error.' + err.data.message);
          }
          else {
            console.error(err.toString())
          }
        })
        .finally(() => {
          if (modal) modal.close();
          this.isEventFired = false;
          $scope.loading = false;
        });
    }, ({ modal }) => {
      if (modal) modal.close();
      this.isEventFired = false;
    }, this.model.routeObj.name, this.checkInDate)
  }

  forceAddBag() {
    const addBagDefer = this.$q.defer();
    const user = this.User.getUser();
    const isSupervisor = user && user.supervisor;
    const supervisorScanRequired = isSupervisor ? this.setupData.supervisorScan : true;

    return this.Modal.checkedInForceAddBag({
      bagId: this.lastScanned,
      branchId: this.model.branch,
      windowId: this.model.window,
      routeId: this.model.route,
      date: this.checkInDate,
      supervisorScan: supervisorScanRequired,
      branchVaultDate: this.setupData.currentVaultDate,
      cancelSupervisorChallenge: this.setupData.cancelSupervisorChallenge
    }, ({ modal, $scope }) => {
      $scope.bag.routeId = this.model.route;
      $scope.bag.pickupDate = $scope.bag.pickupDate;
      $scope.bag.pickupTime = $scope.bag.pickupTime;
      $scope.bag.convertPickupDate = true;
      $scope.bag.branchTimeZone = this.setupData.timezone;
      this.ShipmentService.create($scope.bag)
        .then((res) => {
          this.model.bagId = res.trackingId
          this.isCheckinSuccessfull = true;
          this.isEventFired = false;
          this.isError = '';
          modal.close();
          // this.autoSubmit()
          this.wasItemFound = true;
          this.isManuallyAddedShipment = true;
          this.bagCheckOutError = '';
          this.bagCheckOutMessage = '';
          this.lastStatusUpdate = '';
          // this.verifyRoute(this.model.route, this.checkInDate)
          addBagDefer.resolve($scope.bag)
        })
        .catch((err) => {
          if (err && err.data && err.data.errors) {
            this.Sound.PlayErrorBeep("#scanner_beep");
            this.Modal.errorModal("error." + err.data.errors[0].path);
          }
          else if (err && err.data && err.data.message) {
            this.Sound.PlayErrorBeep("#scanner_beep");
            this.Modal.errorModal(err.data.message);
          }
          else {
            console.log(err);
          }
        })
      addBagDefer.promise
        .then((data) => {
          return this.createTransaction(data)
        })
    }, ({ modal }) => {
      this.focusElementById('bagId')
      this.isEventFired = false;
      if (modal) modal.close();
    });
  }

  submitManifest = function () {
    if (!(this.manifest.totalBagCount > 0)) return;
    if (this.manifest.isSubmitting || this.manifest.isCompleted) return;
    this.manifest.isSubmitting = true;
    this.ShipmentService.createCheckinManifest(this.shipmentData.shipment.fromLocationId, this.vaultDate, this.model.route, this.manifest.totalBagCount, this.manifest.manifestID, this.loggedInUser)
      .then((data) => {
        this.manifest.isCompleted = true;
        this.callCheckinBag().then(() => {
          this.Sound.playSuccessBeep("#success_beep");
          this.resetManifestForm();
        })
      }).catch((err) => {
        this.manifest.isCompleted = false;
        console.log(err);
      }).finally(() => {
        this.manifest.isSubmitting = false;
      })
  };

  resetManifestForm() {
    this.manifest = {
      showManifestModal: false,
      totalBagCount: null,
      manifestID: null,
      isSubmitting: false,
      isCompleted: false,
    };
  }

  // create transaction record
  createTransaction(shipmentData) {
    const transData = {
      tranType: 'PICKUP',
      trackingId: shipmentData.trackingId,
      transactionDate: moment.utc(),
      sequence: 0,
      amount: shipmentData.amount,
      qty: shipmentData.qty,
      bagSeal: null,
      comments: 'Manually Added to Checkin',
      sentOnRoute: 0,
      sentEndOfDay: 0,
      routeId: shipmentData.routeId,
      toLocationId: shipmentData.toLocationId,
      fromLocationId: shipmentData.fromLocationId,
      performedById: this.loggedInUser,
      shiptypeId: shipmentData.shiptypeId,
      branchId: this.model.branch
    }
    this.TransactionService.create(transData)
      .then(() => {
        return this.verifyBag();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.Modal.errorModal(err.data.message);
        }
      })
  }

  verifyBag() {
    this.ShipmentService.verifyShipment(this.model.branch, this.model.bagId, this.model.route, this.checkInDate, this.model.window, this.model.fromTanker, this.model.toTanker)
      .then(() => {
        this.isError = false;
        return this.autoSubmit();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.lastStatusUpdate = new Date();
          this.isError = true;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.bagCheckinError = this.$translate.instant('error.' + err.data.message) || null;
          this.lastScanned = this.model.bagId;
          this.clearScan();
        }
      })
  }

  clearScan(clearError) {
    var fieldsToClear = ['bagId', 'destination', 'availableDestinations', 'amount', 'shiptype', 'quantity', 'shipper']
    fieldsToClear.forEach((field) => {
      delete this.model[field]
      delete this.newValues[field]
    })
    this.resetManifestForm();
    this.bagIdCopy = '';
    this.model.bagId = '';
    this.isAmountChanged = this.isDestinationChanged = this.isShipperChanged = false;

    this.isEditingShipper = false;
    this.selectedShipperLocation = null;
    this.originalShipperLocationId = null;
    this.trueOriginalShipperLocationId = null;
    this.originalShipperLocationObj = null;

    if (clearError) {
      this.lastStatusUpdate = undefined;
      this.bagCheckinError = '';
      this.bagCheckinMessage = '';
      this.shipmentChangeMessage = '';
      this.isError = false;
    }
    this.bagScanLimitExceed = false;
    this.checkOnlyOnce = false;
    this.isEventFired = false;
    this.setFocus();
  }

  shipmentAmountChanged(field) {
    if (field === 'quantity') {
      if (this.newValues.quantity) {
        this.newValues.amount = this.newValues.quantity * this.newValues.shiptypeUnitAmount;
      }
    }
    if (field === 'shiptype') {
      const selectedShiptype = this.shiptypes.find((shiptype) => {
        return shiptype.id === this.newValues.shiptype;
      });

      this.newValues.shiptypeUnitAmount = selectedShiptype.amount
      this.model.coinFlag = selectedShiptype.coinFlag

      if (this.model.coinFlag) {
        if (this.newValues.quantity) {
          this.newValues.amount = this.newValues.quantity * this.newValues.shiptypeUnitAmount
        }
      }
      else {
        this.newValues.amount = this.model.amount
        this.newValues.quantity = 1
      }
    }

    const keys = ['destination', 'shiptype', 'amount', 'quantity'];
    this.isAmountChanged = keys.some((key) => {
      
      if(key === 'amount'){
        setTimeout(()=>{
          if(this.newValues.amount !== null && this.newValues.amount <= 1 && this.newValues.amount !== ''){
            this.Sound.PlayErrorBeep("#scanner_beep");
          }
        },500)
      }

      return this.newValues[key] !== this.model[key];
    });
  }

  saveChanges() {
    const proceed = (supId, modal) => {
      let destinationChangePromise = this.$q.when().promise;
      let amountChangePromise = this.$q.when().promise;
      let date = this.checkInDate;
      this.shipmentChangeMessage = '';
      this.bagCheckinMessage = '';
      this.isError = false;
      delete this.lastStatusUpdate;

      if (this.isDestinationChanged) {
        destinationChangePromise = this.ShipmentService.changeShipmentDestination(this.model.bagId, this.model.route, date, this.newValues.destination.id)
          .then((data) => {
            this.model.destination = this.newValues.destination;
            this.isDestinationChanged = false;
            return;
          });
      }

      if (this.isAmountChanged) {
        amountChangePromise = this.ShipmentService.changeShipmentAmount
        (this.model.id, this.model.bagId, this.model.route, date, this.newValues.shiptype, this.newValues.quantity, this.newValues.amount,
         this.branchId, this.model.amount, supId)
          .then((data) => {
            this.model.quantity = this.newValues.quantity;
            this.model.amount = this.newValues.amount;
            this.isAmountChanged = false;
            return;
          });
      }

      this.$q.all([
        destinationChangePromise,
        amountChangePromise
      ])
        .then(() => {
          if (this.isShipperChanged) {
            this.originalShipperLocationId = this.model.shipper.Value;
            this.originalShipperLocationObj = {
              name: this.model.shipper.name,
              address: this.model.shipper.address,
              Value: this.model.shipper.Value,
              Key: this.model.shipper.Key
            };
            this.selectedShipperLocation = this.model.shipper;
            this.isShipperChanged = false;
          }
          this.isError = false
          this.lastStatusUpdate = new Date()
          this.shipmentChangeMessage = this.$translate.instant('checkin.successfullySaved');
          // return this.autoSubmit()
          // if (this.checkAndCall == true) {
          // return this.bagSubmitted()
          // }
        })
        .then(() => {
          return this.verifyShipments();
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.model.bagId = "";
            this.Sound.PlayErrorBeep("#scanner_beep");
            this.Modal.errorModal('error.' + err.data.message);
          }
        })
        .finally(() => {
          // this.Sound.PlayErrorBeep("#scanner_beep");
          if (modal) {
            modal.close();
          }
        });
    };

    const user = this.User.getUser();
    const isSupervisor = user && user.supervisor;
    const supervisorScanRequired = isSupervisor ? this.setupData.supervisorScan : true;

    if (supervisorScanRequired) {
      this.Modal.confirmSupervisor('save-shipment-changes', { trackingId: this.model.bagId }, ({ modal, supId }) => {
        proceed(supId, modal);
      }, ({ modal }) => {
        modal.close();
      });
    } else {
      proceed(this.loggedInUser, null);
    }
  }

  verifyShipments() {
    this.ShipmentService.verifyShipment(this.model.branch, this.model.bagId, this.model.route, this.checkInDate, this.model.window, this.model.fromTanker, this.model.toTanker)
      .then(() => {
        return this.bagSubmitted()
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          delete this.shipmentChangeMessage;
          this.isError = true;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.bagCheckinError = this.$translate.instant('error.' + err.data.message) || null;
          this.lastScanned = this.model.bagId;
          // this.model.bagId = "";
          this.verifyRoute(this.model.route, this.checkInDate)
          this.clearScan();
        }
      })
  }

  resetChanges() {
    this.newValues = {
      destination: this.model.destination,
      shiptype: this.model.shiptype,
      amount: this.model.amount,
      quantity: this.model.quantity
    };

    if (this.isShipperChanged) {
      this.model.shipper = this.originalShipperLocationObj;
      this.selectedShipperLocation = this.originalShipperLocationObj;
      this.isShipperChanged = false;
    }

    this.isDestinationChanged = false;
    this.isAmountChanged = false;
  }

  resetModel() {
    this.hasMessenger = false
    this.hasRoute = false
    this.hasWindow = false
    this.hasFromTanker = false
    this.hasToTanker = false
    this.overridenBySupervisor = false
    this.showCheckin = false

    this.model = {
      route: undefined,
      branch: this.User.getUser().branchId,
      customer: undefined,
      window: undefined,
      fromTanker: undefined,
      toTanker: undefined,
      shipper: {},
      loadTruck: null
    }
    this.availableDestinations = [];
    this.availableDestination = [];
    this.isError = false;
    this.bagCheckinError = '';
    this.bagCheckinMessage = '';
    this.shipmentChangeMessage = '';

    this.resetNewValues();
  }

  resetNewValues() {
    this.newValues = {
      destination: {},
      shiptype: '',
      amount: '',
      quantity: ''
    };

    //not a changable value but reset it as all the other values that are displayed are also cleared
    this.model.shipper = {};

    this.isDestinationChanged = false
    this.isAmountChanged = false;
  }

  printManifest() {
    // const new_path = `${this.$location.protocol()}://${this.$location.host()}:${this.$location.port()}/print-checkin/${this.branchId}/${this.closedRoute}/${this.vaultDate}`ul   // this.$window.open(new_path, '_blank')

    const url = this.$state.href('printCheckin', {
      branchId: this.branchId,
      scannedRouteId: this.closedRoute,
      date: this.vaultDate
    });

    window.w = window.open(url, '_blank');
    window.w.printData = {
      itemList: this.logisticItemObj.checkedInItemList
    };
  }

  shipmentInfo(isShpCheckedIn) {
    this.Modal.routeCheckinInfo(isShpCheckedIn, this.model.route, this.vaultDate, this.model.branch, this.remainingToCheckin, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    })
  }

  scanPrefix(prefixType, field) {
    if (this.model[field] && this.prefixes && this.prefixes[prefixType]) {
      if (this.model[field].startsWith(this.prefixes[prefixType][0])) {
        this.model[field] = this.model[field].slice(this.prefixes[prefixType][0].length).trim();
      }
    }
  }

  refreshData() {
    this.model.refreshItems = true;
    this.verifyRoute(this.model.route, this.checkInDate)
      .then(() => {
        this.clearScan(true);
        this.clearItemScan();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal('error.' + err.data.message)
        }
      })
      .finally(() => {
        this.model.refreshItems = false;
      })
  }

  getSelectedDestination(destinations) {
    if (!destinations || !destinations.length || _.isEmpty(this.Shipmentresponse)) return;
    const toLoc = destinations.filter(d => d.id == this.Shipmentresponse.toLocationId);

    if (toLoc && toLoc.length) return Object.assign({}, ...toLoc);
    return destinations;
  }

  tabSelection(selectedValue) {
    this.model.currentItemStat = selectedValue;
  }

  checkInTabSelection(selectedValue) {
    this.currentCheckInTab = selectedValue;
    if (this.currentCheckInTab === this.checkInScanTab.items) {
      this.clearItemScan();
      this.model.currentItemStat = this.itemStats.items;
    }
    else if (this.currentCheckInTab === this.checkInScanTab.shipment) {
      this.clearScan();
      this.model.currentItemStat = this.itemStats.cash;
    }
  }

  remainingLogisticItemList() {
    this.Modal.logisticItemList(this.model.route, this.logisticItemObj.remainingItemList, 'remaining', ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    });
  }

  logisticItemCheckedInList() {
    this.Modal.logisticItemList(this.model.route, this.logisticItemObj.checkedInItemList, 'checkedIn', ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    });
  }

  clearItemScan() {
    this.logisticItemObj.barcode = null;
    this.logisticItemObj.itemScanLimitExceed = false;
    this.logisticItemObj.allowItemScanOnce = false;
    this.logisticItemObj.disableItemScan = false;
    this.logisticItemObj.defaultLength = 0;
    this.logisticItemObj.lastUpdated = null;
    this.logisticItemObj.lastScannedItem = null;
    this.logisticItemObj.isError = false;
    this.logisticItemObj.itemCheckInError = null;
    this.logisticItemObj.itemCheckInMessage = null;
    this.logisticItemObj.itemScanError = null;
    this.logisticItemObj.itemDetails = {};
    this.logisticItemObj.wasItemFound = false;
    this.focusElementById('barcode');
  }

  itemScanKeyPress($event) {
    const ESC_KEY_CODE = 27;
    const BACKSPACE_KEY_CODE = 8;
    if ($event.keyCode === ESC_KEY_CODE) return this.clearItemScan();
    if ($event.keyCode === BACKSPACE_KEY_CODE && this.logisticItemObj.barcode && this.logisticItemObj.barcode.length <= 1) return this.clearItemScan();
  }

  logisticItemScan() {
    this.logisticItemObj.barcode = this.scanSuffix(this.logisticItemObj.barcode);

    if (!this.logisticItemObj.barcode) return;

    this.logisticItemObj.itemScanLimitExceed = false;
    this.logisticItemObj.isError = false;
    this.logisticItemObj.itemCheckInMessage = null;

    if (this.bagScanLimit && this.bagScanLimit > 0) {
      if (this.logisticItemObj.barcode.length > this.bagScanLimit &&
        (!this.logisticItemObj.allowItemScanOnce || this.logisticItemObj.barcode.length !== this.logisticItemObj.defaultLength)) {
        delete this.logisticItemObj.itemCheckInError;
        delete this.logisticItemObj.itemCheckInMessage;
        this.logisticItemObj.itemScanLimitExceed = true;
        this.logisticItemObj.allowItemScanOnce = true;
        this.logisticItemObj.lastScannedItem = this.logisticItemObj.barcode;
        this.logisticItemObj.defaultLength = this.logisticItemObj.barcode.length;
        this.logisticItemObj.barcode = "";
        this.logisticItemObj.isError = true;
        this.logisticItemObj.lastUpdated = new Date();
        return this.logisticItemObj.itemScanError = this.$translate.instant('common.bagScanError');
      }
      else {
        this.logisticItemObj.defaultLength = this.logisticItemObj.barcode.length > this.bagScanLimit ? this.logisticItemObj.barcode.length : this.bagScanLimit;
      }
    }

    this.logisticItemObj.itemDetails = this.logisticItemObj.remainingItemList.find(item => item.barcode.toUpperCase() == this.logisticItemObj.barcode);
    if(this.logisticItemObj.itemDetails) this.logisticItemObj.wasItemFound = true;
    else if(_.isEmpty(this.logisticItemObj.itemDetails)) this.logisticItemObj.wasItemFound = false;

    delete this.logisticItemObj.lastUpdated;
    if (!this.autoSubmitItem) {
      if (this.logisticItemObj.barcodeCopy === this.logisticItemObj.barcode && this.logisticItemObj.wasItemFound) {
        this.logisticItemObj.isItemCheckedIn = false;
        return this.logisticItemSubmitted();
      }
      else if (!this.logisticItemObj.wasItemFound) {
        this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
        return this.logisticItemSubmitted();
      }
      else {
        this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
      }
    }
    else if (this.autoSubmitItem) {
      this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
      return Promise.resolve();
    }
  }

  logisticItemSubmitted() {
    if (!this.logisticItemObj.barcode) return;
    const successMessage = this.$translate.instant('item.checked_in');

    return this.ItemService.logisticItemCheckIn(this.branchId, this.logisticItemObj.barcode, this.user.id, this.logisticItemObj.itemDetails ? this.logisticItemObj.itemDetails.keepRouteAssignment : 0)
      .then(() => {
        this.logisticItemObj.itemCheckInMessage = successMessage;1
        this.logisticItemObj.isItemCheckedIn = true;
        this.logisticItemObj.itemDetails = {};
        this.verifyRoute(this.model.route, this.checkInDate);
      })
      .catch((err) => {
        this.logisticItemObj.isItemCheckedIn = false;
        this.logisticItemObj.isError = true;

        if (err && err.data && err.data.message) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.logisticItemObj.itemCheckInError = this.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        }
        else {
          this.logisticItemObj.itemCheckInError = err.toString();
        }
      })
      .finally(() => {
        this.logisticItemObj.barcode = null;
        this.logisticItemObj.lastUpdated = new Date();
        this.logisticItemObj.lastScannedItem = this.logisticItemObj.barcodeCopy;
        this.logisticItemObj.barcodeCopy = null;
      })
  }

  autoSubmitItems($event) {
    const promise = this.logisticItemScan($event);

    if (promise && typeof promise.then === "function") {
      promise.then(() => {
        setTimeout(() => {
          this.logisticItemSubmitted();
        }, 700)
      })
    }

    return promise;
  }

  setFocus() {
    if (this.currentCheckInTab === this.checkInScanTab.items) {
      this.focusElementById('barcode');
    }
    else if (this.currentCheckInTab === this.checkInScanTab.shipment) {
      this.focusElementById('bagId');
    }
  }

  logisticItemBulkHold() {
    return this.ItemService.logisticItemBulkHold(this.model.route, this.branchId, this.vaultDate, this.user.id, this.logisticItemObj.remainingItemList)
      .then().catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal('error.' + err.data.message)
        }
      })
  }

  getCheckinUserAssignedItems(){
    this.ScanService.getCheckinUserAssignedItems(this.model.routeObj.routeId, this.model.branch, this.model.messengerId)
      .then((res) => {
        this.logisticItemObj.remainingItemList = res.data.remainingItemList || [];
        this.logisticItemObj.remainingItemsCount = res.data.remainingItemList.length || 0;
        this.logisticItemObj.checkedInItemList = this.routeVerifyData.checkedInItemList || [];
        this.logisticItemObj.checkedInItemsCount = res.data.checkedInItemList.length || 0;
        this.routeVerifyData.errorCount = 0;
        this.remainingCheckinItemCount = 0;
        this.remainingToCheckin = [];
        if (this.routeVerifyData.route) {
          this.routeVerifyData.route.forEach((record) => {

            switch (record.message) {
              case 'E_PICKUP_NOT_CHECKED_IN':
              case 'E_DELIVERY_NOT_DELIVERED':
                if (!(record.isRequiredPickup === 1 && !record.orderNo && record.verified === 0)) {
                  this.remainingCheckinItemCount++
                  this.remainingToCheckin.push(record);
                }
                break;
            }

            if (record.isError || record.message === 'E_LOCATION_NOT_ON_HOLD') {
              this.routeVerifyData.errorCount++
            }
          })
          this.routeVerifyData.errorCount = this.routeVerifyData.errorCount + this.logisticItemObj.remainingItemsCount;
        }
    })
  }

}

export default CheckInController



// WEBPACK FOOTER //
// ./client/app/components/checkin/checkin.controller.js